import { render, staticRenderFns } from "./SeniorMembersList.vue?vue&type=template&id=5b5dd2f4"
import script from "./SeniorMembersList.vue?vue&type=script&lang=js"
export * from "./SeniorMembersList.vue?vue&type=script&lang=js"
import style0 from "./SeniorMembersList.vue?vue&type=style&index=0&id=5b5dd2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports